import React from 'react';
import { Package, Link2, Settings, BarChart3 } from 'lucide-react';
import styles from './HowItWorks.module.css';
import { useScrollAnimation, useStaggerAnimation } from '../hooks/useScrollAnimation';

const STEPS = [
  {
    num: '01',
    icon: Package,
    title: 'Pick your plan',
    desc: 'Choose a monthly engagement subscription or a one-time karma build. Every plan is clear — no hidden limits or confusing add-ons.',
  },
  {
    num: '02',
    icon: Link2,
    title: 'Submit your brief',
    desc: 'Share your Reddit post URL or account URL, your target subreddits, and any specific instructions. We do the rest.',
  },
  {
    num: '03',
    icon: Settings,
    title: 'We get to work',
    desc: "Our network of aged, karma-rich Reddit accounts delivers engagement gradually — the way real organic activity looks to Reddit's algorithm.",
  },
  {
    num: '04',
    icon: BarChart3,
    title: 'Track results live',
    desc: 'Log in to your dashboard to watch delivery in real time — upvote counts, comment placements, karma progress, and monthly reports.',
  },
];

export default function HowItWorks() {
  const headRef = useScrollAnimation();
  const gridRef = useStaggerAnimation();

  return (
    <section className={styles.section} id="how">
      <div className="container">
        <div className={`${styles.head} fade-up`} ref={headRef}>
          <div className="section-label">How it works</div>
          <h2 className="section-title">Simple. Fast. Done for you.</h2>
          <p className="section-sub">
            Four steps from checkout to results. You don't touch Reddit. We handle everything.
          </p>
        </div>

        <div className={styles.grid} ref={gridRef}>
          {STEPS.map((step) => (
            <div key={step.num} className={`${styles.step} stagger-child`}>
              <div className={styles.stepNum}>{step.num}</div>
              <div className={styles.stepIcon}>
                <step.icon size={28} strokeWidth={2} className="text-accent" />
              </div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDesc}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
